<template>
  <div class="row mt-2 border-top pt-2 bg-light">
    <div class="col-12 col-md-5">
      <h4 class="px-2">Bill Summary</h4>
      <table class="table create-billing border table-totals">
        <tbody>
          <tr>
            <td class="product px-2">Net Bill Amount</td>
            <td class="comma-sep">:</td>
            <td class="price text-right px-2">{{ total }}</td>
          </tr>
          <tr>
            <td>
              <div class="product px-2 d-flex w-100">
                <span class="w-100">Discount / Round up Adj</span>
                <div class="price-adj d-flex align-items-center">
                  <input
                    v-model.trim="discountPercent"
                    type="number" 
                    class="form-control form-control-sm discount-adj ml-auto text-right"
                    placeholder="%" 
                    :min="0"
                    @keydown.enter="$emit('print')"
                  >
                  <span class="ml-1">%</span>
                </div>
              </div>
              <div v-if="discountAmount > 0" class="p-1">
                <v-select
                  placeholder="Select Discount Head"
                  v-model="formData.discount_head_id"
                  :options="salesAccountHeads"
                  label="name"
                  :reduce="name => name.id"
                />
              </div>
            </td>
            <td class="comma-sep">:</td>
            <td class="price">
              <div class="price-adj px-2">
                <input
                  v-model.trim="discountAmount"
                  type="number" 
                  class="form-control form-control-sm discount-adj ml-auto text-right"
                  placeholder="amount" 
                  :min="0"
                >
              </div>
            </td>
          </tr>
          <tr>
            <td class="product px-2 font-20"><strong>Net Payable</strong></td>
            <td class="comma-sep">:</td>
            <td class="price text-right px-2">
              <input
                v-model.trim="grandTotal"
                type="number"
                class="form-control form-control-lg discount-adj ml-auto text-right font-weight-bold text-primary"
                placeholder="amount"
                :min="0"
                @keyup="setDiscountAmount"
                @keydown.enter="$emit('print')"
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="col-12 col-md-7 d-flex align-items-center justify-content-end pr-4">
      <div class="action-buttons mb-2 mt-2">
        <button class="btn btn-sm btn-outline-primary" @click="$emit('newBill')">
          <i class="fa fa-plus mr-1"></i> New Bill
        </button>
        <button class="btn btn-sm btn-outline-danger mx-1" @click="$emit('clear')">
          <i class="fa fa-refresh mr-1"></i> Clear
        </button>
        <button class="btn btn-sm btn-success" @click="$emit('print')">
          <i class="fa fa-print mr-1"></i> Print
        </button>
      </div>
    </div>
  </div>
</template>


<script setup>
import { inject, toRef } from 'vue';
import useInvoiceCalculations from '@/composables/useInvoiceCalculations.js';

const props = defineProps({
  tableItems: Array,
  salesAccountHeads: Array
});

const emit = defineEmits(['clear', 'newBill', 'print']);

const formData = inject('formData');
const totals = inject('totals');
const tableItemsRef = toRef(props, 'tableItems');

const {
  total,
  grandTotal,
  discountAmount,
  discountPercent,
  setDiscountAmount,
  resetDiscounts
} = useInvoiceCalculations(tableItemsRef, totals);

defineExpose({
  resetData: resetDiscounts
});
</script>

<style scoped>
.font-20 {
  font-size: 20px;
}
.create-billing {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
.discount-adj {
    max-width: 150px;
}
</style>
